import { render, staticRenderFns } from "./GradeEnrollDialog.vue?vue&type=template&id=38874180&scoped=true&"
import script from "./GradeEnrollDialog.vue?vue&type=script&lang=js&"
export * from "./GradeEnrollDialog.vue?vue&type=script&lang=js&"
import style0 from "./GradeEnrollDialog.vue?vue&type=style&index=0&id=38874180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38874180",
  null
  
)

export default component.exports